import { Link, useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft, LayoutGrid, HeartPulse, Settings as SettingsIcon, FileText } from "lucide-react";
import Logo from "./Logo";

export const AppShell = ({
  children,
  showBack = false,
  backTo,
  title,
  testId = "app-shell",
  showTabBar = false,
  activeTab,
  showTopBar = true,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (backTo) navigate(backTo);
    else navigate(-1);
  };

  return (
    <div
      className="min-h-screen w-full relative"
      style={{ background: "var(--ta-bg)" }}
      data-testid={testId}
    >
      {showTopBar && (
        <header className="sticky top-0 z-30 backdrop-blur-md" style={{ background: "rgba(249,248,246,0.85)" }}>
          <div className="w-full max-w-screen-md mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
            <div className="flex items-center gap-3">
              {showBack ? (
                <button
                  onClick={handleBack}
                  data-testid="back-button"
                  className="inline-flex items-center justify-center w-11 h-11 -ml-2 rounded-full active:scale-95 transition-transform"
                  style={{ color: "var(--ta-primary)" }}
                  aria-label="Go back"
                >
                  <ChevronLeft size={26} strokeWidth={2.2} />
                </button>
              ) : (
                <Logo />
              )}
              {title && (
                <span className="font-display text-lg font-medium" style={{ color: "var(--ta-primary)" }}>
                  {title}
                </span>
              )}
            </div>
            {showBack && <Logo size="sm" />}
          </div>
        </header>
      )}

      <main className="w-full max-w-screen-md mx-auto px-5 sm:px-8 pb-32 page-fade">
        {children}
      </main>

      {showTabBar && (
        <nav
          className="fixed bottom-0 left-0 right-0 z-30 border-t"
          style={{ background: "rgba(255,255,255,0.92)", backdropFilter: "blur(12px)", borderColor: "var(--ta-border)" }}
          data-testid="bottom-tabbar"
        >
          <div className="w-full max-w-screen-md mx-auto px-4 h-20 flex items-center justify-around">
            <TabItem to="/dashboard" label="Home" icon={LayoutGrid} active={activeTab === "home"} testId="tab-home" />
            <TabItem to="/brief" label="Brief" icon={FileText} active={activeTab === "brief"} testId="tab-brief" />
            <TabItem to="/health" label="Health" icon={HeartPulse} active={activeTab === "health"} testId="tab-health" />
            <TabItem to="/settings" label="Settings" icon={SettingsIcon} active={activeTab === "settings"} testId="tab-settings" />
          </div>
        </nav>
      )}
    </div>
  );
};

const TabItem = ({ to, label, icon: Icon, active, testId }) => (
  <Link
    to={to}
    data-testid={testId}
    className="flex flex-col items-center justify-center gap-1 min-w-[60px] py-2 active:scale-95 transition-transform"
    style={{ color: active ? "var(--ta-primary)" : "var(--ta-text-secondary)" }}
  >
    <Icon size={22} strokeWidth={active ? 2.4 : 1.8} />
    <span className="text-[11px] font-medium" style={{ fontFamily: "Work Sans" }}>{label}</span>
  </Link>
);

export default AppShell;
